import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * BinaryRepoFilesApi - axios parameter creator
 * @export
 */
const BinaryRepoFilesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (id, options = {}) => {
            const localVarPath = `/v1/BinaryRepoFiles/Get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {string} [key]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadBanner: async (id, key, options = {}) => {
            const localVarPath = `/v1/BinaryRepoFiles/UploadBanner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {string} [key]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadProduct: async (id, key, options = {}) => {
            const localVarPath = `/v1/BinaryRepoFiles/UploadProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * BinaryRepoFilesApi - functional programming interface
 * @export
 */
const BinaryRepoFilesApiFp = function (configuration) {
    const localVarAxiosParamCreator = BinaryRepoFilesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BinaryRepoFilesApi.get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {string} [key]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadBanner(id, key, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadBanner(id, key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BinaryRepoFilesApi.uploadBanner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {string} [key]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadProduct(id, key, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadProduct(id, key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BinaryRepoFilesApi.uploadProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * BinaryRepoFilesApi - factory interface
 * @export
 */
const BinaryRepoFilesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BinaryRepoFilesApiFp(configuration);
    return {
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, options) {
            return localVarFp.get(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {string} [key]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadBanner(id, key, options) {
            return localVarFp.uploadBanner(id, key, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {string} [key]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadProduct(id, key, options) {
            return localVarFp.uploadProduct(id, key, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BinaryRepoFilesApi - object-oriented interface
 * @export
 * @class BinaryRepoFilesApi
 * @extends {BaseAPI}
 */
class BinaryRepoFilesApi extends BaseAPI {
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BinaryRepoFilesApi
     */
    get(id, options) {
        return BinaryRepoFilesApiFp(this.configuration).get(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [id]
     * @param {string} [key]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BinaryRepoFilesApi
     */
    uploadBanner(id, key, options) {
        return BinaryRepoFilesApiFp(this.configuration).uploadBanner(id, key, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [id]
     * @param {string} [key]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BinaryRepoFilesApi
     */
    uploadProduct(id, key, options) {
        return BinaryRepoFilesApiFp(this.configuration).uploadProduct(id, key, options).then((request) => request(this.axios, this.basePath));
    }
}

export { BinaryRepoFilesApi, BinaryRepoFilesApiAxiosParamCreator, BinaryRepoFilesApiFactory, BinaryRepoFilesApiFp };
//# sourceMappingURL=binary-repo-files-api.js.map
